export default __webpack_public_path__ + "static/media/lipstick-hot-spring.1f4e1466.png";